{
  "fr": {
    "textExtract": {
      "alerts": {
        "limitReached": "Vous avez atteint votre limite pour les extractions de texte."
      },
      "buttons": {
        "extract": "Extraire du texte",
        "processing": "Traitement en cours..."
      },
      "errors": {
        "processingFailed": "L'extraction de texte a échoué. Veuillez réessayer."
      },
      "inputKinds": {
        "file": {
          "dropTitle": "Faites glisser le fichier ici ou {select}",
          "dropTitleSelect": "sélectionner",
          "help": "Déposez le fichier ici ou sélectionnez-le. Les images, PDF, texte, audio ainsi que les formats Office et OpenOffice courants jusqu'à {limit} Mo sont pris en charge.",
          "label": "Fichier",
          "maxSize": "Maximum {limit} Mo",
          "placeholder": "Sélectionner un fichier",
          "title": "Fichier",
          "icon": "bi-file-earmark"
        },
        "audio": {
          "help": "Astuce : Vous pouvez glisser-déposer un fichier directement. Nous prenons en charge les fichiers .mp3, .mp4, .mp4a ou .wav jusqu'à {limit}MB.",
          "icon": "bi-file-music",
          "label": "Fichier audio",
          "placeholder": "Sélectionner un fichier audio",
          "title": "Fichier audio"
        },
        "image": {
          "help": "Astuce : Vous pouvez glisser-déposer un fichier directement. Nous prenons en charge les fichiers .jpeg, .png jusqu'à {limit}MB.",
          "icon": "bi-image",
          "label": "Fichier image",
          "placeholder": "Sélectionner un fichier image",
          "title": "Image"
        },
        "pdf": {
          "help": "Astuce : Vous pouvez glisser-déposer un fichier directement. Nous prenons en charge les fichiers .pdf jusqu'à {limit}MB.",
          "icon": "bi-file-earmark-pdf",
          "label": "Fichier PDF",
          "placeholder": "Sélectionner un fichier PDF",
          "title": "PDF"
        },
        "video": {
          "help": "Astuce : Vous pouvez glisser-déposer un fichier directement. Nous prenons en charge les fichiers .mp4, .mp4v, .avi ou .mkv jusqu'à {limit}MB.",
          "icon": "bi-film",
          "label": "Fichier vidéo",
          "placeholder": "Sélectionner un fichier vidéo",
          "title": "Fichier vidéo"
        },
        "website": {
          "label": "URL du site web",
          "placeholder": "https://fobizz.com/was-ist-fobizz/",
          "title": "Site web",
          "help": "Exemple : https://fobizz.com/was-ist-fobizz/",
          "icon": "bi-globe"
        },
        "youtube": {
          "label": "URL YouTube ou recherche",
          "placeholder": "Entrer une URL YouTube ou rechercher des vidéos...",
          "title": "YouTube",
          "help": "Insérer une URL YouTube ou rechercher des vidéos à transcrire",
          "icon": "bi-youtube"
        },
        "text": {
          "label": "Texte",
          "placeholder": "Vous pouvez ici ajouter des connaissances de fond vous-même...",
          "title": "Texte"
        }
      },
      "labels": {
        "language": "Langue",
        "inputType": "Type d'entrée"
      },
      "modal": {
        "title": "Extraire du texte"
      },
      "sourcePicker": {
        "addNew": "Ajouter",
        "recent": "Dernière utilisation"
      },
      "upload": {
        "success": "Fichier téléchargé avec succès"
      },
      "options": {
        "languages": {
          "auto": "Reconnaître automatiquement"
        }
      },
      "youtube": {
        "noResults": "Aucune vidéo trouvée pour votre recherche.",
        "searchError": "Erreur lors de la recherche des vidéos. Veuillez réessayer."
      },
      "privacyHint": "Ne partagez pas d'informations sensibles ou de données personnelles d'élèves avec une IA."
    }
  }
}
